module.exports = __webpack_public_path__ + "img/mp4.eb6baddf.png";